import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import MarketingService from '../../../api/MarketingService'
import moment from 'moment'

interface CampaignDetails {
  title: string
  route: string
  reception_type: string
  description: string
  message_to_reception: string
  campaign_time: string
  campaign_date: any[] // Assuming dates are stored as strings
  status: number
}

export default function UserDetails() {
  const {id} = useParams()

  const [campaign, setCampaign] = useState<CampaignDetails>({
    title: '',
    route: '',
    reception_type: '',
    description: '',
    message_to_reception: '',
    campaign_time: '',
    campaign_date: [],
    status: 0,
  })

  // init
  useEffect(() => {
    getCampaignById()
  }, [])

  const getCampaignById = () => {
    MarketingService.getCampaignById(Number(id)).then(
      (res: any) => {
        if (res?.data?.success) {
          const campaignData = res?.data?.data
          setCampaign({
            title: campaignData.title,
            route: campaignData.route,
            reception_type: campaignData.reception_type,
            description: campaignData.description,
            message_to_reception: campaignData.message_to_reception,
            campaign_time: campaignData.campaign_time,
            campaign_date: campaignData.campaign_date,
            status: campaignData.status,
          })
        } else {
          clearCampaign()
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        clearCampaign()
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  const clearCampaign = () => {
    setCampaign({
      title: '',
      route: '',
      reception_type: '',
      description: '',
      message_to_reception: '',
      campaign_time: '',
      campaign_date: [],
      status: 0,
    })
  }

  const dates = campaign.campaign_date
    .map((date) => moment(date.campaign_date).format('MMM D, YYYY'))
    .join('\n')

  return (
    <div className='container'>
      <div style={{width: '100%'}}>
        <button
          className='bg-transparent border-0'
          onClick={() => {
            window.history.back()
          }}
        >
          <i
            className='fa fa-angle-left py-2 px-3'
            aria-hidden='true'
            style={{background: '#fff', borderRadius: '50%'}}
          ></i>{' '}
          <span className='fw-bold fs-5 px-2'>Back</span>
        </button>
      </div>
      <form
        className='col-lg-12 row p-6 m-4'
        style={{background: '#fff', marginTop: 30, borderRadius: '5px'}}
      >
        <div className='row'>
          <div className='form-group col-lg-4'>
            <label htmlFor='title'>Title</label>
            <input type='text' className='form-control' value={campaign.title} disabled />
          </div>
          <div className='form-group col-lg-4'>
            <label htmlFor='route'>Route</label>
            <select className='form-control form-select' value={campaign.route} disabled>
              <option value=''>Select Route</option>
              <option value={1}>Email</option>
              <option value={2}>SMS</option>
            </select>
          </div>
          <div className='form-group col-lg-4'>
            <label htmlFor='reception_type'>Recipients Type</label>
            <select className='form-control form-select' value={campaign.reception_type} disabled>
              <option value=''>Select reception_type</option>
              <option value={1}>All Leads</option>
              <option value={2}>Individual</option>
              <option value={3}>Company</option>
            </select>
          </div>
          <div className='form-group col-lg-12 mt-4'>
            <label htmlFor='description'>Description</label>
            <textarea className='form-control' value={campaign.description} disabled />
          </div>
          <div className='form-group col-lg-12 mt-4'>
            <label htmlFor='messageToRecipients'>Message To Recipients</label>
            <textarea className='form-control' value={campaign.message_to_reception} disabled />
          </div>
          <div className='form-group col-lg-4 mt-4'>
            <label htmlFor='date'>Campaign Dates</label>
            <textarea className='form-control' value={dates} disabled />
          </div>
          <div className='form-group col-lg-4 mt-4'>
            <label htmlFor='time'>Time</label>
            <input type='text' className='form-control' value={campaign.campaign_time} disabled />
          </div>
          <div className='form-group col-lg-4 mt-4'>
            <label htmlFor='status'>Status</label>
            <input
              type='text'
              className='form-control'
              value={campaign.status === 0 ? 'In-active' : 'Active'}
              disabled
            />
          </div>
        </div>
        {/* <div className='form-group mb-2'>
          <label>Permissions</label>
          <div
            className='w-100 d-flex justify-content-between flex-wrap overflow-y-auto py-2'
            style={{height: 'auto'}}
          >
            {permissionList.map((permission: any) => (
              <div className='form-check w-lg-50 w-50 mb-2' key={permission.value}>
                <input
                  className='form-check-input'
                  id={permission.value}
                  type='checkbox'
                  checked={user.permissions.includes(permission.value)}
                  readOnly
                />
                <label className='form-check-label' htmlFor={permission.value}>
                  {permission.label}
                </label>
              </div>
            ))}
          </div>
        </div> */}
        {/* <div className='modal-footer'>
                    <button type='submit' className='btn btn-primary' style={{borderRadius: 85}}>
                    Invite User
                    </button>
                </div> */}
      </form>
    </div>
  )
}
